import { PkSpinner } from '@uefadigital/panenka-react';
import { memo } from 'react';

import { useStatistics } from '../../hooks/stats';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

export const Loader = () => {
  const t = useTranslateFn();
  const { isLoading } = useStatistics();

  if (!isLoading) return null;

  return (
    <div className={styles.overlay}>
      <PkSpinner size={40} type='portrait'>
        <span slot='primary'>{t('stats_wait')}</span>
        <span slot='secondary'>{t('stats_updating')}</span>
      </PkSpinner>
    </div>
  );
};

export default memo(Loader);
